import Vue from 'vue'
import { SearchService } from '~/utils/services/serchService'
import { areasInParent, experiencePage, searchLocations, searchPopularLocations } from '~/utils/server'
import axios from '~/services/apiClient'
import { isObject } from '~/utils/v'
import { capitalizeFirstLetter } from '~/utils/utils'
import { CACHE_SETTINGS } from '~/utils/cache'
import GTM from '~/utils/classes/Gtm'
import { SEARCH_BOAT_ANY_TYPE_ID } from '~/utils/search/search.constants'

export const state = () => ({
  bar: {
    current: {
      rawLocation: '',
      location: '',
      date: '',
      boat_type: ''
    },
    prev: {
      rawLocation: '',
      location: '',
      date: '',
      boat_type: ''
    }
  },
  Search: null,
  term: [],
  location: {
    id: null,
    name: '',
    ulr: null
  },
  destination: null,
  areas: null,
  loading: true,
  locationFull: null,
  locationsFull: null,
  locations: [],
  date: null, // dayjs().weekday(6).format('YYYY-MM-DD')
  duration: 7,
  boatType: null,
  boatTypeSlug: null,
  charterType: null,
  charterTypeSlug: null,
  sortBy: '-premium_boat',
  renting: {},
  filters: {},
  results: [],
  amountResultsFound: {},
  hasBeenFiltered: {},
  pagination: {},
  searchTerms: {
    sortBy: '-premium_boat'
  },
  limit_date: true,
  sortOptions: [
    // { id: 0, title: 'sort-by', },
    /* { id: '-price', title: 'price-high-to-low', route: { name: 'search', query: { sortBy: '-price' } } }, */
    { id: '+price', title: 'price-low-to-high', route: { name: 'search', query: { sortBy: '+price' } } },
    { id: '+discount', title: 'discount-high-to-low', route: { name: 'search', query: { sortBy: '+discount' } } },
    { id: '-year', title: 'year-new-to-old', route: { name: 'search', query: { sortBy: '-year' } } },
    { id: '+year', title: 'year-old-to-new', route: { name: 'search', query: { sortBy: '+year' } } },
    { id: '-rating', title: 'rating-high-to-low', route: { name: 'search', query: { sortBy: '-rating' } } },
    /* { id: '+rating', title: 'rating-low-to-high', route: { name: 'search', query: { sortBy: '+rating' } } }, */
    { id: '-premium_boat', title: 'premium-boat-first', route: { name: 'search', query: { sortBy: '-premium_boat' } } },
    { id: '-length', title: 'length-long-to-short', route: { name: 'search', query: { sortBy: '-length' } } },
    { id: '+length', title: 'length-short-to-long', route: { name: 'search', query: { sortBy: '+length' } } }

  ],
  sortOptionsDs: [
    // { id: 0, title: 'sort-by', },
    { id: '-premium_boat', title: 'premium-boat-first', route: { name: 'search', query: { sortBy: '-premium_boat' } } },
    { id: '+discount', title: 'discount-high-to-low', route: { name: 'search', query: { sortBy: '+discount' } } },
    { id: '+price', title: 'price-low-to-high', route: { name: 'search', query: { sortBy: '+price' } } },
    { id: '-rating', title: 'rating-high-to-low', route: { name: 'search', query: { sortBy: '-rating' } } },
    { id: '-year', title: 'year-new-to-old', route: { name: 'search', query: { sortBy: '-year' } } },
    { id: '-length', title: 'length-long-to-short', route: { name: 'search', query: { sortBy: '-length' } } },
    { id: '+length', title: 'length-short-to-long', route: { name: 'search', query: { sortBy: '+length' } } }
    /* { id: '-price', title: 'price-high-to-low', route: { name: 'search', query: { sortBy: '-price' } } },

    { id: '+year', title: 'year-old-to-new', route: { name: 'search', query: { sortBy: '+year' } } },
    { id: '+rating', title: 'rating-low-to-high', route: { name: 'search', query: { sortBy: '+rating' } } }, */
  ],
  lastSearchPayload: {},
  searchPageState: {},
  boatTypes: [],
  staticBoatTypes: [],
  filterShowLimits: {},
  canBeReset: true,
  autocomplete: {
    value: null,
    locale: null,
    data: undefined,
    loading: false,
    popular: []
  }
})

export const getters = {
  terms: (state, rootState) => {
    return {
      start_date: state.date,
      guests: state.guests !== undefined ? state.guests : 1,
      location: state.location ? state.location.url : '',
      duration: state.duration !== undefined ? state.duration : 0,
      sortBy: state.sortBy !== undefined ? state.sortBy : 0,
      currency: rootState.lang.currentCurrency ? rootState.lang.currentCurrency : 'EUR'
    }
  },
  searchTerms: state => state.searchTerms,
  filters: state => state.filters,
  filter: state => state.filter,
  sortOptions: state => state.sortOptions,
  sortOptionsDs: state => state.sortOptionsDs,
  searchPageState: state => state.searchPageState,
  duration: state => state.duration,
  boatTypes: state => state.boatTypes,
  loading: state => state.loading,
  bar: state => state.bar,
  autocomplete: state => state.autocomplete,
  location: state => state.location
}

export const mutations = {
  SET_BAR (state, { condition, data = {} }) {
    Vue.set(state.bar, condition, { ...state.bar[condition], ...data })
  },
  SET_LIMIT_DATE (state, value) {
    state.limit_date = value
  },
  SET_SEARCH_PAGE_STATE (state, data) {
    if (isObject(data)) {
      state.searchPageState = { ...state.searchPageState, ...data }
      return
    }
    state.searchPageState = data
  },
  SET_LAST_SEARCH_PAYLOAD (state, data) {
    state.lastSearchPayload = {
      ...data,
      __time: new Date()
    }
  },
  SET_SEARCH_TERMS (state, data) {
    Vue.set(state, 'searchTerms', data)
  },
  SET_LOCATION (state, value) {
    state.location = value
  },
  SET_DESTINATION (state, value) {
    state.destination = value
  },
  SET_BOAT_TYPE (state, value) {
    state.boatType = value
  },
  SET_BOAT_TYPE_SLUG (state, value) {
    state.boatTypeSlug = value
  },
  SET_LOCATION_NAME (state, value) {
    if (!state.location) {
      state.location = {
        name: ''
      }
    }
    state.location.name = value
  },
  SET_DATE (state, value) {
    const cd = new Date()
    let m = cd.getUTCMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = cd.getDate()
    d = d < 10 ? '0' + d : d
    const dt = cd.getFullYear() + '-' + m + '-' + d
    if (value <= dt) {
      value = dt
    }
    state.date = value
  },
  SET_DURATION (state, value) {
    state.duration = parseInt(value, 10) || 7
  },
  SET_LOADING (state, value) {
    state.loading = value
  },
  SET_LOCATIONS (state, value) {
    state.locations = value
  },
  SET_AREAS (state, value) {
    state.areas = value
  },
  SET_LOCATION_FULL (state, value) {
    state.locationFull = value
  },
  SET_LOCATIONS_FULL (state, value) {
    state.locationsFull = value
  },
  SET_FILTERS (state, data) {
    this.$Search.filtersObject = data
    state.filters = this.$Search.filtersObject
  },
  SET_RESULTS (state, value) {
    state.results = value
  },
  SET_AMOUNT_RESULTS_FOUND (state, value) {
    state.amountResultsFound = value
  },
  SET_FILTERED (state, value) {
    state.hasBeenFiltered = value
  },
  SET_PAGINATION (state, value) {
    state.pagination = value || {}
  },
  SET_BOAT_TYPES (state, data) {
    state.boatTypes = [
      { id: SEARCH_BOAT_ANY_TYPE_ID, name: 'any-types', slug: 'any', icon: 'bt-any', translate: true },
      ...data
    ]
  },
  SET_STATIC_BOAT_TYPES (state, data) {
    state.staticBoatTypes = data
  },
  SET_TERMS_FILTER (state, { key, value }) {
    // if (!key) {
    //   return
    // }
    // if (value === null) {
    //   const defaultTerms = getDefaultTerms()
    //   value = dcopy(defaultTerms[getFilterTypeKeys(key, { fromKey: 'routerKey' }).routerKey])
    // }
    // Vue.set(state.searchTerms, getFilterTypeKeys(key, { fromKey: 'routerKey' }).routerKey, value)
  },
  SET_FILTERS_SHOW_LIMITS (state, data) {
    state.filterShowLimits = data
  },
  RESET_FILTERS_SHOW_LIMITS (state) {
    for (const [key, _] of Object.entries(state.filterShowLimits)) {
      state.filterShowLimits[key] = 5
    }
  },
  SET_CAN_BE_RESET (state, data) {
    state.canBeReset = data
  },
  SET_AUTOCOMPLETE (state, object) {
    for (const [key, value] of Object.entries(object)) {
      state.autocomplete[key] = value
    }
  }
}
const _search = new SearchService(axios)

export const actions = {
  async getLocation ({ commit, rootState }, { locationUrl, lang, locations = [] }) {
    const cacheKey = {
      locationUrl,
      lang,
      locations: locations.join(',')
    }

    const location = await this.$cacheFetch({
      key: `getLocation?${JSON.stringify(cacheKey)}`,
      expire: CACHE_SETTINGS.location
    }, async () => {
      const res = await this.$aProxy.get(`/proxy?proxyUrl=/search/location/${encodeURI(locationUrl)}&language=${lang}&locations=${locations.join(',')}`)
      return res.data
    })

    commit('SET_LOCATION', {
      name: location.data.location[location.data.type],
      url: location.data.urls[location.data.type]
    })
    commit('SET_LOCATION_FULL', { ...location.data })
    commit('SET_LOCATIONS_FULL', [location.data, ...(location?.locations || [])])
    return location
  },
  async getDestinationInfo ({ commit }, { lang, location, boatType }) {
    const { data } = await experiencePage(location, null, lang, boatType)
    commit('SET_DESTINATION', data)
  },
  async getAreasInfo ({ commit, state }) {
    const { data } = await areasInParent(state.destination.area.location.id)
    commit('SET_AREAS', data)
  },
  async urlConfig ({ commit }, path) {
    try {
      const { data } = await this.$aProxy.post('/proxy?proxyUrl=/search/' +
        'url-config', { path })
      if (data && data.boat_type_id) {
        commit('SET_BOAT_TYPE', data.boat_type_id)
      }
    } catch (e) {
      console.log(e)
    }
  },
  startSearch ({ state, commit, rootGetters }, terms) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)
      _search.post(this, terms).then((res) => {
        resolve()
        if (!res.data.error) {
          const fullLocationIds = state.locationFull?.ids
          const gtm = new GTM(this.$gtm)

          if (!res.data?.results?.length) {
            gtm.searchEmpty({
              route: this.app.router.currentRoute,
              other: {
                location: Object.map(fullLocationIds, (acc, k, v) => {
                  return { ...acc, [`${k}_id`]: v }
                })
              }
            })
          } else {
            gtm.search({
              route: this.app.router.currentRoute,
              other: {
                location: Object.map(fullLocationIds, (acc, k, v) => {
                  return { ...acc, [`${k}_id`]: v }
                })
              }
            })
          }
          let companyStatus = res.data.filters.company_status ?? []
          if (companyStatus.length) {
            companyStatus = companyStatus.map((item) => {
              item.key = parseInt(item.key)
              return item
            })
          }
          res.data.filters.company_status = companyStatus

          commit('SET_FILTERED', res.data.hasBeenFiltered)
          commit('SET_FILTERS', res.data.filters)
          commit('SET_RESULTS', res.data.results)
          commit('SET_LOCATIONS', res.data.locations)
          commit('SET_AMOUNT_RESULTS_FOUND', res.data.numFound)
          commit('SET_PAGINATION', res.data.pagination)
        } else {
          console.error(res)
          commit('SET_RESULTS', [])
          commit('SET_PAGINATION', {})
        }
        commit('SET_LOADING', false)
        resolve()
      }).catch((e) => {
        console.error(e)
        commit('SET_LOADING', false)
        commit('SET_RESULTS', [])
        commit('SET_PAGINATION', {})
        reject(e)
      })
    })
  },
  clearSearch ({ commit }) {
    commit('SET_SEARCH_TERMS', null)
  },
  changeSearchTerms ({ commit }, data) {
    commit('SET_SEARCH_TERMS', data)
  },
  changeFilter ({ commit }, { key = null, value = null }) {
    commit('SET_TERMS_FILTER', { key, value })
  },
  changeSearchPageState ({ commit }, data) {
    commit('SET_SEARCH_PAGE_STATE', data)
  },
  async getAutocompletePopular ({ commit, rootGetters }) {
    const locale = rootGetters['lang/locale']
    if (rootGetters['search/autocomplete'].popular?.length && locale === rootGetters['search/autocomplete'].locale) {
      return
    }
    try {
      let data = await searchPopularLocations(rootGetters['lang/locale'])

      data = data?.map((i) => {
        return {
          ...i,
          raw: i.name,
          name: i.title
        }
      })

      commit('SET_AUTOCOMPLETE', { popular: data, locale })
    } catch (e) {
      console.debug(e)
    }
  },
  setBoatTypes ({ commit, rootState }, data) {
    const boatTypes = rootState.data.boat.boatTypes.filter(bt => bt.in_search_bar).map((t) => {
      const transType = t.values.find(v => v.language.shortcode === rootState.lang.locale) ?? t?.values[0]
      const name = transType.name
      return {
        ...t,
        name,
        key: t.id,
        slug: transType.slug
      }
    })

    const result = [
      { id: 9999, key: 9999, name: 'any-types', slug: 'any', icon: 'bt-any', translate: true },
      ...boatTypes.map((tb) => {
        return {
          ...tb,
          icon: `bt-${tb.id}`,
          name: capitalizeFirstLetter(tb.name),
          order_by: tb.order_by
        }
      }).sort((a, b) => a.order_by - b.order_by)
    ]

    commit('SET_STATIC_BOAT_TYPES', result)
    commit('SET_BOAT_TYPES', result)
  },
  async getAutocomplete ({ commit, rootGetters }, value) {
    commit('SET_AUTOCOMPLETE', { loading: true, value })
    try {
      let data = await searchLocations(value?.trim(), rootGetters['lang/locale'])

      data = data?.map((i) => {
        return {
          ...i,
          raw: i.name,
          name: i.title
        }
      })

      commit('SET_AUTOCOMPLETE', { data: data.length ? data : null, loading: false })
    } catch (e) {
      console.debug(e)
      commit('SET_AUTOCOMPLETE', { loading: false, data: null })
    }
  }
}
